// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import './styles.css'

import appStoreApple from '../Assets/appstore_apple.png'
import appStoreGoogle from '../Assets/appstore_google.png'

export default class SendMoneyNoWink extends Component {
    render() {
        return (
            <Grid fluid>
                <Row center="sm">
                    <Col xs={12} sm={12} md={12} lg={8}>
                        <div className='mainContainer'>
                            <Row center="xs">
                                <Col >
                                    <div className='winkTopLogo'></div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='tittle'>Tu cuenta en Wink está lista</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='message'>Sólo tenés que abrir la aplicación para comenzar a usar Wink</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <a href='wink://log-in' className='btn-primary-outline'>ABRIR EN WINK</a>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={12}>
                                    <div className='warningMessage'>Sos parte de la familia Wink. Si necesitás cualquier cosa no dudes
                                        contactarnos a través del chat de soporte del App. Nuestro <a href="#">Centro de Soporte</a> siempre está para ayudarte.</div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/ConfirmEmail/index.js